import Repository from './functionRepository'

const endpoint = 'braze'

export default {
    getAllSegmentList() {
        return Repository.get(`${endpoint}/segments`)
    },
    getAllCampaignsList() {
        return Repository.get(`${endpoint}/campaigns`)
    },
    uploadContentCard(request) {
        return Repository.post(`${endpoint}/content-card`, request);
      }
}